import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Tag } from "primereact/tag";
import { Toast } from "primereact/toast";

import Menu from "../../../components/Menu";

import api from "../../../services/api";

export default function EficienciaTeares() {
    const [data, setData] = useState([]);

    const toast = useRef();

    const fetchData = useCallback(() => {
        api.get("eficiencia-teares").then((response) => {
            setData(response.data);
        }).catch((error) => {
        });
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        let interval = setInterval(() => {
            fetchData();
        }, 1000 * 60);

        return () => {
            clearInterval(interval);
        }
    }, [fetchData]);

    return (
        <div>
            <Toast ref={toast} />
            <Menu />
            <Card
                className="p-m-1"
                title="Eficiência Baixa"
            >
                <div className="p-d-flex p-flex-row p-jc-end">
                    <Button
                        className="p-button-success p-m-2"
                        icon="pi pi-refresh"
                        onClick={fetchData}
                    />
                </div>
                {data.map((grupo, index) => (
                    <div key={`grupo${index}`}>
                        <div>
                            <h3 className="p-m-0 p-p-2 p-text-center">GRUPO {grupo.grupo}</h3>
                            <h3 className="p-m-0 p-p-1 p-text-center">Eficiência Média: {Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(grupo.eficiencia_grupo)}%
                            </h3>
                        </div>
                        <DataTable
                            emptyMessage="Nenhum tear encontrado."
                            responsiveLayout="scroll"
                            value={grupo.teares}
                        >
                            <Column header="Tear" field="tear" sortable alignHeader="center" align="center" body={(rowData) => {
                                return (
                                    <Tag severity="info" style={{ fontSize: 24 }}>{rowData.tear}</Tag>
                                )
                            }} />
                            <Column header="Eficiência" field="eficiencia" alignHeader="center" align="center" sortable body={(rowData) => {
                                return (
                                    <Tag severity="danger" style={{ fontSize: 24 }}>
                                        {rowData.eficiencia + "%"}
                                    </Tag>
                                )
                            }} />
                        </DataTable>
                    </div>
                ))}

            </Card>
        </div>
    )
}